module.exports = __webpack_public_path__ + "img/discover2.9d35fe5c.png";